import { IntegratedEmailsPermissions } from './integrated-emails.permissions';
import { IntegratedEmailsRoles } from './integrated-emails.roles';

export const integratedEmailsMappings = {
  [IntegratedEmailsPermissions.SEND_EMAIL]: [IntegratedEmailsRoles.SENDER],
};
